import { render, staticRenderFns } from "./PaymentsSingleCardView.vue?vue&type=template&id=396dc55a&scoped=true"
import script from "./PaymentsSingleCardView.vue?vue&type=script&lang=js"
export * from "./PaymentsSingleCardView.vue?vue&type=script&lang=js"
import style0 from "./PaymentsSingleCardView.vue?vue&type=style&index=0&id=396dc55a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dc55a",
  null
  
)

export default component.exports